import {
  SET_USER,
  HTTP_USER_REQUEST,
  HTTP_USER_REQUEST_FAILURE,
  HTTP_USER_REQUEST_SUCCESS,
} from "./usuarioTypes";

const initialState = {
  loading: false,
  error: "",
  data: "",
};

export const usuarioReducers = (state = initialState, action) => {
  switch (action.type) {
    case HTTP_USER_REQUEST:
      return { ...state, loading: true };
    case HTTP_USER_REQUEST_SUCCESS:
      return { ...state, data: action.payload, loading: false };
    case HTTP_USER_REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_USER:
      return { ...state, data: action.payload };
    default:
      return state;
  }
};
